import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import "./AuthPage.css";

function AuthPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  // ✅ SAVE USER IN SUPABASE TABLE
  const saveUserToDatabase = async (user) => {
    try {
      await fetch("/api/save-user", {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          uid: user.id,
          name:
            user.user_metadata?.full_name ||
            user.user_metadata?.name ||
            "",

          email: user.email || "",
          phone: "",
        }),
      });
    } catch (err) {
      console.error("SAVE USER ERROR:", err);
    }
  };

  // SAME FLOW FOR OTP + GOOGLE
  const redirectAfterLogin = (user) => {

  if (
    user?.email?.endsWith("@codeion.in")
  ) {

    navigate(
      "/instructor-dashboard",
      {
        replace: true,
      }
    );

  } else {

    navigate("/dashboard", {
      replace: true,
    });

  }
};

  useEffect(() => {
    const checkSession = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (session?.user) {
        await saveUserToDatabase(session.user);

        redirectAfterLogin(session.user);
      }
    };

    checkSession();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        if (
          event === "SIGNED_IN" &&
          session?.user
        ) {
          // ✅ SAVE USER
          await saveUserToDatabase(
            session.user
          );

          redirectAfterLogin(session.user);
        }
      }
    );

    return () => subscription.unsubscribe();
  }, []);

  // OTP SEND
  const handleSendOtp = async () => {
    try {
      setLoading(true);
      setMsg("");

      const { error } =
        await supabase.auth.signInWithOtp({
          email: email.trim(),

          options: {
            shouldCreateUser: true,
          },
        });

      if (error) throw error;

      setStep(2);

      setMsg("OTP sent successfully.");
    } catch (error) {
      setMsg(error.message);
    } finally {
      setLoading(false);
    }
  };

  // OTP VERIFY
  const handleVerifyOtp = async () => {
    try {
      setLoading(true);
      setMsg("");

      const {
        data,
        error,
      } = await supabase.auth.verifyOtp({
        email: email.trim(),
        token: otp.trim(),
        type: "email",
      });

      if (error) throw error;

      // ✅ SAVE USER
      if (data?.user) {
        await saveUserToDatabase(
          data.user
        );
      }

      redirectAfterLogin(data.user);
    } catch {
      setMsg("Invalid OTP.");
    } finally {
      setLoading(false);
    }
  };

  // GOOGLE LOGIN
  const handleGoogleLogin = async () => {
    try {
      setLoading(true);
      setMsg("");

      await supabase.auth.signOut();

      const { error } =
        await supabase.auth.signInWithOAuth({
          provider: "google",

          options: {
            redirectTo:
              "https://www.codeion.in",

            queryParams: {
              prompt: "select_account",
            },
          },
        });

      if (error) throw error;
    } catch (error) {
      setMsg("Google login failed.");
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-shell">

        <section className="auth-left-panel">
          <div className="auth-badge">
            Modern Learning Platform
          </div>

          <div className="auth-copy">
            <h1>
              Learn with <span>CODEION</span>
            </h1>

            <p>
              Build future-ready tech skills
              through practical learning,
              mentorship, real projects,
              and career-focused programs.
            </p>
          </div>

          <div className="auth-feature-card">
            <div className="auth-feature-item">
              <span>✓</span>

              <p>
                Industry-ready courses &
                projects
              </p>
            </div>

            <div className="auth-feature-item">
              <span>✓</span>

              <p>
                Smart dashboards
              </p>
            </div>

            <div className="auth-feature-item">
              <span>✓</span>

              <p>
                Secure OTP Login
              </p>
            </div>
          </div>
        </section>

        <section className="auth-right-panel">
          <div className="auth-card">

            <div className="auth-head">
              <span className="auth-step">
                Step {step} of 2
              </span>

              <h2>Welcome Back</h2>

              <p>
                Continue your journey.
              </p>
            </div>

            <input
              type="email"
              placeholder="Enter Gmail"
              value={email}
              onChange={(e) =>
                setEmail(e.target.value)
              }
            />

            {step === 2 && (
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) =>
                  setOtp(e.target.value)
                }
              />
            )}

            {step === 1 ? (
              <button
                className="auth-btn"
                onClick={handleSendOtp}
                disabled={loading}
              >
                {loading
                  ? "Sending..."
                  : "Send OTP"}
              </button>
            ) : (
              <button
                className="auth-btn"
                onClick={handleVerifyOtp}
                disabled={loading}
              >
                {loading
                  ? "Verifying..."
                  : "Verify OTP"}
              </button>
            )}

            {msg && (
              <p className="auth-msg">
                {msg}
              </p>
            )}

            {/*
            <div className="auth-divider">
              <span>OR</span>
            </div>
            */}

           {/*
            <button
              className="google-btn"
              onClick={handleGoogleLogin}
              disabled={loading}
            >
              Continue with Google
            </button> 
            */}

          </div>
        </section>

      </div>
    </div>
  );
}

export default AuthPage;